export async function isPdfProtectedOrCorrupted(
  blob: Blob
): Promise<'corrupted' | 'protected' | undefined> {
  // pdf-lib and its standard-fonts dependency are 344 KB and this is the only
  // place either is used. A static import puts them in the eager vendor chunk
  // on every page load; importing here keeps them out until someone actually
  // prints a PDF. The function was already async, so no caller changes.
  //
  // Deliberately outside the try: a chunk that fails to load is a load error,
  // not a corrupted file, and the caller in usePrintFile already turns a
  // rejection into a generic print error rather than blaming the document.
  const { PDFDocument } = await import('pdf-lib')

  try {
    const pdf = await PDFDocument.load(await blob.arrayBuffer(), {
      ignoreEncryption: true
    })

    if (pdf.isEncrypted) {
      return 'protected'
    }
  } catch {
    return 'corrupted'
  }
}
